$ = require 'jquery'
WindowSize = require 'lib/window-size'

$ ->
  WindowSize.calc()

  resize = null
  $(window).resize ->
    clearTimeout(resize)
    resize = setTimeout (-> WindowSize.calc()), 200
    return



// WEBPACK FOOTER //
// ./app/scripts/entry/window-resize-watcher.coffee